import React, {useState} from 'react'
import {Box, SxProps, Theme} from '@mui/material'
import {ICameraSnapshot} from '@containers/cameras/types'

interface IProps {
	snap: ICameraSnapshot
	sx?: SxProps<Theme>
	onClick?: () => void
}

const SegmentPhoto = ({snap, sx, onClick}: IProps) => {
	const [failed, setFailed] = useState(false)
	const src = snap.annotatedUrl && !failed ? snap.annotatedUrl : snap.snapUrl

	return (
		<Box
			component="img"
			src={src}
			alt=""
			sx={sx}
			onClick={onClick}
			onError={() => setFailed(true)}
		/>
	)
}

export default SegmentPhoto
